module.exports = __webpack_public_path__ + "mobile.d5840416.svg";